import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailMask'
})
export class EmailMaskPipe implements PipeTransform {
  transform(plainEmail: string): string {
    const visibleDigits = plainEmail!= undefined ? plainEmail.indexOf('@') - 1:null;
    // // console.log.log(visibleDigits);
    let maskedSection = plainEmail.slice(1, visibleDigits);
    // // console.log.log(maskedSection);
    let visibleSection = plainEmail.slice(visibleDigits);
    return plainEmail[0] + maskedSection.replace(/./g, '*') + visibleSection;
  }
}